<template>
  <div ref="checkout-review">
    <h4>Review Order</h4>
    <v-alert outline color="warning" icon="warning" :value="true">
      Please review your order carefully. ORDERS CANNOT BE CHANGED OR CANCELED after they are submitted to our fully-automated production process.
    </v-alert>

    <v-layout row mt-3>
      <v-flex xs6>
        <h4>
          Shipping Information
          <v-tooltip bottom class="btn-group">
            <v-btn small icon slot="activator" @click.native="$emit('update-step', 1)">
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
            <span>Change Shipping Info</span>
          </v-tooltip>
        </h4>
        <display-address v-if="cart" :data="cart.shipping_address"></display-address>
      </v-flex>
      <v-flex xs6>
        <h4>
          Billing Information
          <v-tooltip bottom class="btn-group">
            <v-btn small icon slot="activator" @click.native="$emit('update-step', 1)">
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
            <span>Change Billing Info</span>
          </v-tooltip>
        </h4>
        <display-address v-if="cart" :data="cart.billing_address"></display-address>
      </v-flex>
    </v-layout>

    <v-layout row mt-3>
      <v-flex xs12>
        <table class="fancy">
          <thead>
            <tr>
              <th class="left-side"></th>
              <th class="left-align">Item Description</th>
              <th class="right-align">Quantity</th>
              <th class="right-align">Unit Price</th>
              <th class="right-align">Extended price</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in cart.cart_items">
              <td class="left-side"></td>
              <td>
                <div class="left mr-3">
                  <img v-if="item.file" :src="item.file.thumbs.small" alt="">
                </div>
                <item-description :item='item'/>
              </td>
              <td class="right-align">{{item.quantity}}</td>
              <td class="right-align">{{unitPrice(item.quantity, item.unit_prices) | currency}}</td>
              <td class="right-align">{{unitPrice(item.quantity, item.unit_prices) * item.quantity | currency}}</td>
            </tr>
          </tbody>
        </table>
        <table class="plain" width="100%">
          <tr>
            <td>
              <br>
              <strong>Shipping Method:</strong>
              {{cart.shipping_method_title}}
              <v-tooltip bottom class="btn-group">
                <v-btn small icon slot="activator" @click.native="$emit('update-step', 2)">
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
                <span>Change Shipping Method</span>
              </v-tooltip>
            </td>
            <td class="right-align semibold">
              Order Total<br>
              Shipping &amp; Processing<br>
              Sales Tax<br>
              Order Total
            </td>
            <td class="right-align">
              {{cart.subtotal_price | currency}}<br>
              {{totalShipping | currency | doubleDashForZero}}<br>
              {{cart.total_tax | currency | doubleDashForZero}}<br>
              {{cart.total_price | currency}}
            </td>
          </tr>
        </table>
      </v-flex>
    </v-layout>

    <v-layout row my-3>
      <v-flex xs12>
        The Order Total of <b class="semibold">{{cart.total_price | currency}}</b> USD will be charged to your Credit Card with Gung-Ho Company as the Merchant.
      </v-flex>
    </v-layout>

    <v-checkbox class="gh-input" v-model="agree" label="I have reviewed my order, read and agree to the Terms and Conditions, and understand my order cannot be changed or canceled after it is submitted."></v-checkbox>
  </div>
</template>

<script>
  import DisplayAddress from '../widgets/display-address'
  import ItemDescription from '../widgets/item-description'

  export default {
    data () {
      return {
      }
    },

    components: {
      displayAddress: DisplayAddress,
      itemDescription: ItemDescription
    },

    filters: {
      doubleDashForZero: function (str) {
        if (str === '$0.00') return '--'
        else return str
      }
    },

    computed: {
      cart: {
        get () {
          return this.$store.state.cart
        },
        set (value) {
          this.$store.commit('saveCart', value)
        }
      },

      hasCartItems () {
        if (!this.cart || !this.cart.cart_items) {
          return false
        }

        return this.cart.cart_items.length > 0
      },

      totalShipping () {
        if (!this.hasCartItems) {
          return 0
        }

        return this.cart.total_shipping
      },

      agree: {
        get () {
          return this.$store.state.agree
        },
        set (value) {
          this.$store.commit('agree', value)
        }
      }
    },

    methods: {
      unitPrice (quantity, prices) {
        if (quantity >= 250) return prices[250]
        else if (quantity >= 100) return prices[100]
        else if (quantity >= 5) return prices[5]
        else return prices[1]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// review-order.vue?a08fc6c4